export default __webpack_public_path__ + "static/media/Minicard_3h.916b162d.svg";